// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/AdminRegistration/components/BrandedBanner/index.css
// module id = 3143
// module chunks = 0